import { combineReducers } from 'redux';
import {
  TEXTBOX_CHANGE_TEXT,
} from '../actions/action-names';

const text = (state = '', action) => {
  switch (action.type) {
    case TEXTBOX_CHANGE_TEXT:
      return action.value;
    default:
      return state;
  }
};

export default combineReducers({
  text,
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/textbox-element-options-reducers.js